import { Controller } from '@hotwired/stimulus'
import 'jquery-validation'

// Connects to data-controller="form-validation"
const csrfToken = document.getElementsByName('csrf-token')[0].content
export default class FormValidationController extends Controller {
  connect() {
    this.add_validator_methods()
    let form_id = '#' + this.element.getAttribute('id')
    const isNewForm = this.element.id == 'new_user'
    const emailRemote = {
      url: `/onboarding/check_user_email${isNewForm ? '' : '?type=update_user'}`,
      type: 'post',
      async: false
    }

    const phoneRemote = {
      url: `/onboarding/check_user_phone${isNewForm ? '' : '?type=update_user'}`,
      type: 'post',
      async: false,
      data: {
        'user[country_code]': () => $('#user_country_code').val()
      }
    }

    $(this.element).validate({
      ignore: ':hidden:not(.timepicker-input), .ignore_validation',
      rules: {
        'user[password]': {
          required: true,
          minlength: 8,
          maxlength: 72,
          password: true
        },
        'showcase[price]': {
          required: true
        },
        'user[website]': {
          customUrl: true
        },
        'user[location]': {
          required: true,
          validCity: true
        },
        'user[current_password]': {
          required: true,
          password: false
        },
        'user[user_name]': {
          required: true,
          pattern: /^\w+$/,
          remote: {
            depends: function (element) {
              return $(element).data('remote') === true
            },
            param: {
              url: '/onboarding/check_user_name',
              type: 'post'
            }
          }
        },
        'user[password_confirmation]': {
          equalTo: '#user_password',
          required: true
        },
        'user[first_name]': {
          required: true,
          minlength: 2,
          maxlength: 255
        },
        'user[last_name]': {
          required: true,
          minlength: 2,
          maxlength: 255
        },
        user_name: {
          remote: {
            url: '/password_reset/check_user',
            type: 'post'
          }
        },
        'user[email]': {
          ...(isNewForm && {
            required: {
              depends() {
                return $('#user_phone_no').val().length === 0
              }
            },
            email_list: true
          }),
          remote: emailRemote,
          maxlength: 255
        },
        'user[phone_no]': {
          ...(isNewForm && {
            required: {
              depends() {
                return $('#user_email').val().length === 0
              }
            }
          }),
          remote: phoneRemote
        },
        code: {
          required: true,
          number: true,
          minlength: 6
        },
        'user[payment_type]': { required: true },
        'user[is_delete]': { required: true },
        'user[delete_account_option]': { required: true },
        'report[report_info_id]': { required: true },
        'report[report_sub_info_id]': { required: true },
        'interest_ids[]': { required: true },
        'admin[password]': {
          required: true,
          minlength: 8,
          maxlength: 72
        },
        'admin[password_confirmation]': {
          equalTo: '#admin_password',
          required: true
        },
        'admin[current_password]': {
          required: true,
          minlength: 8,
          maxlength: 72
        },
        'admin[email]': {
          required: true,
          email: true
        },
        'library_rack[name]': {
          required: true,
          avoidspecialchar: true
        },
        'purchase_backskin[start_date]': {
          required: true,
          futureDate: true
        },
        'purchase_backskin[end_date]': {
          required: true,
          endDateAfterStartDate: '#purchase_backskin_start_date'
        },
        'purchase_backskin[start_time]': {
          required: true,
          invalidTime: true,
          endTimeAfterStartTime: true
        },
        'purchase_backskin[end_time]': {
          required: true,
          invalidTime: true,
          endTimeAfterStartTime: true
        },
        'user[start_time]': {
          invalidTime: true
        },
        'user[end_time]': {
          invalidTime: true
        },
        'user[user_ids][]': {
          required: true
        },
        user_card_id: {
          required: true
        },
        user_address_id: {
          required: true
        },
        'user_address[pin_code]': {
          required: true
        },
        'stripe-card-expiry': {
          required: true
        },
        verify_otp: {
          required: true
        }
      },
      messages: {
        'admin[email]': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.'
        },
        'user[current_password]': {
          required: 'Please enter old password'
        },
        'user[user_ids][]': {
          required: 'Please select any one.'
        },
        code: {
          required: 'Please enter code.',
          number: 'Please enter only digits.',
          minlength: 'Please enter at least 6 digits.',
          maxlength: 'Please enter code not more than 6 digits.'
        },
        'admin[current_password]': {
          password: "current password doesn't not match."
        },
        'admin[password]': {
          required: 'Please enter your password.',
          password:
            'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol.'
        },
        'admin[password_confirmation]': {
          password: 'Please Enter Same Value Again'
        },
        'user[password]': {
          password:
            'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol.'
        },
        'user[password_confirmation]': {
          password:
            form_id == '#change_password'
              ? 'Confirm new password will not match with new password'
              : 'Confirm password must be match with enter password.',
          equalTo: 'Both passwords should match.'
        },
        'user[user_name]': {
          required: "Username can't be blank.",
          pattern: 'Only letters, numbers, and underscores are allowed',
          remote: 'Username already in use!'
        },
        'user[email]': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.',
          email_list: 'Please enter a valid email address.',
          remote: 'Email already in use!'
        },
        'update_user[email]': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.',
          remote: 'Email already in use!'
        },
        'user[phone_no]': {
          required: 'Please enter your Phone number.',
          remote: 'Phone number already in use!'
        },
        'update_user[phone_no]': {
          required: 'Please enter your Phone number.',
          remote: 'Phone number already in use!'
        },
        user_name: {
          remote: "Sorry, We couldn't find account."
        },
        'report[report_info_id]': {
          required: 'Please select one of this options.'
        },
        'report[report_sub_info_id]': {
          required: 'Please select one of this options.'
        },
        'interest_ids[]': {
          required: 'Please select at least 3 interest'
        },
        user_card_id: {
          required: 'Please select a card for payment.'
        },
        user_address_id: {
          required: 'Please select an address.'
        },
        'user_address[pin_code]': {
          required: 'Please enter postal code.'
        },
        'stripe-card-expiry': {
          required: 'Please enter expiry date.'
        },
        verify_otp: {
          required: 'Please enter verification code.'
        }
      },
      onkeyup: false, //Only do validations when form focus changes to avoid exessive ASI calls
      onfocusout: function (element, event) {
        if (
          (event?.relatedTarget &&
            $(event.relatedTarget).is('.skip-validation')) ||
          $(event.relatedTarget).hasClass('flatpickr-day')
        ) {
          return
        }
        const $el = $(element)
        if (
          $el.is(':input') &&
          !$el.is(':password') &&
          $el.attr('type') !== 'file'
        ) {
          $el.val($el.val().trim())
        }
        if (!$el.hasClass('filepond--browser')) $el?.valid()
      },
      errorPlacement: function (error, element) {
        if (element.hasClass('report')) {
          element.closest('.report-list').prepend(error)
        } else if (
          element.hasClass('language') ||
          element.hasClass('interest')
        ) {
          element.closest('.modal-error').prepend(error)
        } else if (element.hasClass('change-password')) {
          element.closest('div').append(error)
        } else if (element.hasClass('phone-no')) {
          element.closest('.form-group').append(error)
        } else if (element.attr('name') === 'nft[image]') {
          element.closest('.nft_form').find('.required-error').prepend(error)
        } else if (element[0].id == 'user_user_name') {
          element?.closest('div')?.parent()?.find('#content_error')?.html('')
          element?.closest('div')?.parent()?.append(error)
        } else {
          element.closest('div').parent('div').append(error)
          // $(form_id).find('button').attr('disabled', 'disabled')
        }
      },
      success: function (label, element) {
        if (element.id == 'user_user_name') {
          $('#user_user_name-error')?.remove()
        }
      }
    })
    $(this.element)
      .find(':input')
      .on('input', function () {
        const $el = $(this)
        if ($el.valid()) {
          $el.removeClass('error')
          $el.closest('div').find('label.error').remove()
        }
      })
    $('.space_not_required').each(function () {
      $(this).rules('add', {
        required: true,
        regex: true
      })
    })
  }

  add_validator_methods() {
    $.extend($.validator.messages, {
      required: function (_, element) {
        const $el = $(element)

        const custom = $el.data('custom-error-field')
        if (custom) return custom

        if (!$el.attr('name')) return 'This field is required.'

        const fieldName = extractFieldName($el.attr('name'))

        if (!fieldName) return 'This field is required.'

        switch (element.type) {
          case 'checkbox':
          case 'select-one':
          case 'radio':
            return `Please select ${fieldName.replaceAll('_', ' ')}`
          case 'file':
            return `Please upload ${fieldName.replaceAll('_', ' ')}`
        }

        return `Please enter ${fieldName.replaceAll('_', ' ')}`
      }
    })

    $.validator.addMethod('password', function (value, element, param) {
      let passwords = value.split(',')
      const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,255}$/
      for (const password of passwords) {
        const trimmed = $.trim(password)
        if (!re.test(trimmed)) {
          return false
        }
      }
      return true
    })
    $.validator.addMethod(
      'customUrl',
      function (value, element) {
        return this.optional(element) || isValidUrl(value)
      },
      'Please enter a valid website.'
    )

    $.validator.addMethod(
      'validCity',
      function (value, element) {
        const touched = $(element).data('city-touched')
        if (!touched) return true

        return (
          this.optional(element) ||
          (element._validCity && element.value === element._validCity)
        )
      },
      'Please select a city from the suggestions.'
    )

    $.validator.addMethod(
      'regex',
      function (value, element, regexp) {
        return value == '' || value.trim().length != 0
      },
      'Space not allow'
    )
    $.validator.addMethod(
      'noSpace',
      function (value, element) {
        return this.optional(element) || /^\S+$/i.test(value)
      },
      'Spaces are not allowed.'
    )
    $.validator.addMethod(
      'noSpecialcharacter',
      function (value, element) {
        let names = value.split(',')
        let re = new RegExp(/\W/i)
        for (const name of names) {
          if (re.test(name)) {
            return false
          }
        }
        return true
      },
      "Don't add Special character"
    )
    $.validator.addMethod(
      'avoidspecialchar',
      function (value, element) {
        let names = value.trim().split(',')
        let re = new RegExp(/^\s+|\s+$|[^\w\s]/)
        for (const name of names) {
          if (re.test(name)) {
            return false
          }
        }
        return true
      },
      "Don't add Special character"
    )
    $.validator.addMethod('pattern', function (value, element, param) {
      if (
        this.optional(element) ||
        $(element)?.data('validate-pattern') === false
      ) {
        return true
      }
      if (typeof param === 'string') {
        param = new RegExp('^(?:' + param + ')$')
      }
      return param.test(value)
    })
    $.validator.addMethod('email_list', function (value, element, param) {
      let emails = value.split(',')
      let re = new RegExp(/^[A-Z0-9._%\-\+\~\/]+@([A-Z0-9-]+\.)+[A-Z]+$/i)
      for (const email of emails) {
        if (!re.test($.trim(email))) {
          return false
        }
      }
      return true
    })
    $.validator.addMethod(
      'endDateAfterStartDate',
      function (value, element, params) {
        const startDateValue = $(params).val()
        if (!startDateValue || !value) return true // don't validate if one is empty

        const start = new Date(startDateValue)
        const end = new Date(value)

        return end >= start
      },
      'End date must be after the start date.'
    )
    $.validator.addMethod(
      'invalidTime',
      function (value, element) {
        return value !== '--:-- --'
      },
      'Please select a valid time.'
    )
    $.validator.addMethod(
      'greaterThan',
      function (value, element, param) {
        const getterMinutes = Number.parseInt(
          $(element).attr('data-greater-minutes') || 0
        )

        const toSeconds = (time) => {
          if (!time) return 0
          const p = time.split(':').map(Number)
          if (p.length === 2) return p[0] * 3600 + p[1] * 60
          if (p.length === 3) return p[0] * 3600 + p[1] * 60 + p[2]
          return 0
        }

        const start = toSeconds($(param).val())
        const end = toSeconds(value)
        const requiredGap = getterMinutes * 60

        if (!start || !end) return true

        return end >= start + requiredGap
      },
      function (params, element) {
        const mins = $(element).attr('data-greater-minutes')
        return `End time must be at least ${mins} minutes greater than start time.`
      }
    )
    $.validator.addMethod(
      'futureDate',
      function (value, element) {
        if (!value) return true

        let inputDate = new Date(value)
        let today = new Date()

        today.setHours(0, 0, 0, 0)

        return inputDate > today
      },
      'Please select a future date'
    )
    $.validator.addMethod(
      'endTimeAfterStartTime',
      function (value, element) {
        this.currentElement = element
        let startDate = $("input[name='purchase_backskin[start_date]']").val()
        let endDate = $("input[name='purchase_backskin[end_date]']").val()
        let startTime = $("input[name='purchase_backskin[start_time]']").val()
        let endTime = $("input[name='purchase_backskin[end_time]']").val()

        if (!endTime || !startDate || !endDate || !startTime) return true

        let now = new Date()
        let todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`

        let [sh, sm] = startTime.split(':')
        let [eh, em] = endTime.split(':')

        let startMinutes = +sh * 60 + +sm
        let endMinutes = +eh * 60 + +em
        let currentMinutes = now.getHours() * 60 + now.getMinutes()

        if (
          startDate === todayStr &&
          startMinutes < currentMinutes &&
          element.classList.contains('start_time')
        ) {
          return false
        }

        if (
          endDate === todayStr &&
          endMinutes <= currentMinutes &&
          element.classList.contains('end_time')
        ) {
          return false
        }

        if (
          startDate === endDate &&
          endMinutes <= startMinutes &&
          element.classList.contains('end_time')
        ) {
          return false
        }

        return true
      },
      function () {
        let startDate = $("input[name='purchase_backskin[start_date]']").val()
        let endDate = $("input[name='purchase_backskin[end_date]']").val()

        let now = new Date()
        let todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`

        if (
          startDate === todayStr &&
          this.currentElement.classList.contains('start_time')
        ) {
          return 'Start time must be after current time.'
        }

        if (
          endDate === todayStr &&
          this.currentElement.classList.contains('end_time')
        ) {
          return 'End time must be after current time'
        }

        if (this.currentElement.classList.contains('end_time'))
          return 'End time must be after start time'
      }
    )
  }
}

function isValidUrl(value) {
  const url = parseUrl(value)
  if (!url) return false

  if (!isHttpProtocol(url)) return false

  const hostname = url.hostname.toLowerCase()

  if (isLocalHostname(hostname)) return false
  if (isPrivateIpv4(hostname)) return false
  if (isLocalIpv6(hostname)) return false
  if (!isPublicDomain(hostname)) return false

  return true
}

function parseUrl(value) {
  try {
    return new URL(value)
  } catch {
    return null
  }
}

function isHttpProtocol(url) {
  return url.protocol === 'http:' || url.protocol === 'https:'
}

function isLocalHostname(hostname) {
  return (
    hostname === 'localhost' ||
    hostname.endsWith('.localhost') ||
    hostname.endsWith('.local')
  )
}

function isPrivateIpv4(hostname) {
  if (!isIpv4(hostname)) return false

  const [a, b] = hostname.split('.').map(Number)

  if (a === 10) return true // 10.0.0.0/8
  if (a === 127) return true // loopback
  if (a === 192 && b === 168) return true // 192.168.0.0/16
  if (a === 169 && b === 254) return true // link-local
  if (a === 172 && b >= 16 && b <= 31) return true // 172.16.0.0 – 172.31.255.255

  return false
}

function isIpv4(hostname) {
  const parts = hostname.split('.')
  if (parts.length !== 4) return false

  return parts.every((part) => {
    if (!/^\d+$/.test(part)) return false
    const num = Number(part)
    return num >= 0 && num <= 255
  })
}

function isLocalIpv6(hostname) {
  return (
    hostname === '::1' || // loopback
    hostname.startsWith('fe80:') || // link-local
    hostname.startsWith('fc') ||
    hostname.startsWith('fd') // unique local
  )
}

function isPublicDomain(hostname) {
  if (!hostname.includes('.')) return false

  const tld = hostname.split('.').pop()
  if (!tld || tld.length < 2) return false

  const specialTlds = new Set(['local', 'localhost', 'test', 'invalid'])
  return !specialTlds.has(tld)
}

function extractFieldName(name) {
  const matches = [...name.matchAll(/\[([^\]]{0,256})\]/g)].map((m) => m[1])

  if (matches.length === 0) return name

  const last = matches.at(-1)
  if (last === '' && matches.length > 1) {
    return matches.at(-2)
  }

  return last
}

function handleAjaxResponse(xhr) {
  if (xhr.responseText.includes('<turbo-stream action')) {
    Turbo.renderStreamMessage(xhr.responseText)
  }
}
